import getAxios from './axiosService'

const listService = {
  getCategory () {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get('/api/book/category')
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get comic category with error', res)
            reject(res.data)
          }
        })
    })
  },
  getBooks (category, currentPage, publishStatus, channel) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.post(`/api/book/query/${channel}/${publishStatus}/${category}/${currentPage}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getLatest (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/book/recent_update?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get latest comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getRanked (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/book/week_rank?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get ranked comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getVIP (target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/book/vip?currentPage=${target}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error('Get VIP comics with error', res)
            reject(res.data)
          }
        })
    })
  },
  getMoreRecommend (target) {
    return getDetailList(target, 'e_recommend')
  },
  getMoreNew (target) {
    return getDetailList(target, 'new')
  },
  getMoreHot (target) {
    return getDetailList(target, 'hot')
  },
  getMoreList (target, type) {
    return getDetailList(target, type)
  },
  getNewList(target) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/book/new/${target}`)
        .then(res => {
          if (res.status === 200 && res.data.result) {
            resolve(res.data)
          } else {
            console.error('Get home detail list with error', res)
            reject(res.data)
          }
        })
    })
  }
}

function getDetailList (target, type) {
  return new Promise((resolve, reject) => {
    const axios = getAxios(true)
    axios.get(`/api/book/showcase/detail/${type}/${target}`)
      .then(res => {
        if (res.status === 200 && res.data.result) {
          resolve(res.data)
        } else {
          console.error('Get home detail list with error', res)
          reject(res.data)
        }
      })
  })
}

export default listService
